import { useState, useCallback, useEffect, useContext } from 'react';
import { BasicDetails, ChannelConfiguration, PaymentDetails, CompanyDetails } from './components';
import { ProfileDetailsContext } from 'providers/profile-provider';
import { TabList } from 'components/generic';
import { profileSectionList } from 'config';
import { useDispatch } from 'react-redux';
import { clientSlice } from 'redux/reducers';
import { useFetch } from 'hooks';
import { cloneDeep } from 'lodash';
import './style.scss';

const MyProfile = () => {
	const context = useContext(ProfileDetailsContext);
	const { originalObj, setCreateObj, setOriginalObj } = context;
	const [activeSection, setActiveSection] = useState('basic_details');

	const dispatch = useDispatch();
	const api = useFetch();

	// change the active tab
	const handleSectionClick = e => {
		setCreateObj(cloneDeep(originalObj));
		setActiveSection(e?.key);
	};

	const getClientData = async () => {
		const c_id = localStorage.getItem('c_id');
		const { data } = await api({ url: `client/v1/?c_id=${c_id}`, method: 'get' });
		const clientConfig = data?.data;
		if (clientConfig) {
			setCreateObj(clientConfig);
			setOriginalObj(cloneDeep(clientConfig));
			dispatch(clientSlice?.actions?.clientReducer(clientConfig));
		}
	};

	const updateClient = async obj => {
		const form = new FormData();
		form.append('op_clientConfig', JSON.stringify(obj));
		form.append('op_formContent', obj?.c_formData?.op_formContent);
		form.append('op_currentSection', obj?.c_formData?.op_currentSection);
		form.append('op_status', obj?.c_formData?.op_status);
		form.append('op_medium', 'APPLICATION');
		if (activeSection === 'company_details') {
			form.append('c_identityProof', obj?.c_verification?.c_businessRegVerification?.c_identityProof);
			form.append('c_registrationCertificate', obj?.c_verification?.c_businessRegVerification?.c_registrationCertificate);
			form.append('c_financialStatement', obj?.c_verification?.c_businessRegVerification?.c_financialStatement);
			form.append('c_logo', obj?.c_companyDetails?.basic_details?.c_logo);
		}
		await api({ url: 'client/v1/updateClient', method: 'patch', data: form });
		await getClientData();
	};

	const handleButtonClick = async data => {
		data?.key === 'save' && (await updateClient(data?.createObj));
		data?.key === 'cancel' && setCreateObj(cloneDeep(data?.createObj));
	};

	// display the active section
	const displayActiveSection = useCallback(() => {
		const obj = {
			basic_details: () => <BasicDetails onSave={() => getClientData()} />,
			channel_configuration: () => <ChannelConfiguration onClickButton={handleButtonClick} />,
			payment_details: () => <PaymentDetails onClickButton={handleButtonClick} />,
			company_details: () => <CompanyDetails onClickButton={handleButtonClick} />,
			DEFAULT: () => null
		};
		return (obj[activeSection] || obj['DEFAULT'])();
	}, [activeSection]);

	useEffect(() => {
		getClientData();
	}, []);

	return (
		<>
			<TabList tabList={profileSectionList} tabActive={activeSection} handleTabClick={handleSectionClick} />
			{displayActiveSection()}
		</>
	);
};

export default MyProfile;
